import Splide from '@splidejs/splide';
window.BlockBlog = () => {
    return {
        // eslint-disable-next-line no-undef
        ajax_url: ajax_object.ajax_url,
        posts_per_page: 9,
        page: 1,
        posts: [],
        initBlog() {
            this.getPosts();
        },
        resetPosts() {
            this.page = 1;
            this.posts = [];
        },
        getPosts() {
            fetch(this.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({
                    action: 'get_blog',
                    paged: this.page,
                }),
            }).then((response) => response.json())
                .then((data) => {
                    this.posts = this.posts.concat(data);
                })
                .catch((error) => console.log(error));
            
            this.page++
        
        },
        slider() {
            new Splide( this.$el, {
                padding: '20%',
                perPage: 2,
                perMove: 2,
                gap: '50px',
                type: 'loop',
                arrows: false,
                pagination: false,
                autoplay: true,
                easing: 'ease',
                speed: 600,
                breakpoints: {
                    640: {
                        perPage: 1,
                        padding: '0px',
                    },
                    1280: {
                        perPage: 1,
                        padding: '20%',
                    },
                },
            }).mount();
        },
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Blog.js